import { createSlice } from '@reduxjs/toolkit';
import { getAllZoneType, getZoneTypeDetailById } from './actions';

const initialState = {
  data: {},
  selected: {},
  isLoading: false,
  isError: false,
  errorMessage: '',
};

export const zoneType = createSlice({
  name: 'zoneType',
  initialState,
  reducers: {
    resetZoneTypeSelected: (state) => {
      state.selected = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllZoneType.pending, (state) => {
        state.data = {};
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = '';
      })
      .addCase(getAllZoneType.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(getAllZoneType.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.errorMessage = '';
        state.data = action.payload;
      })
      .addCase(getZoneTypeDetailById.pending, (state) => {
        state.selected = {};
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = '';
      })
      .addCase(getZoneTypeDetailById.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(getZoneTypeDetailById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.errorMessage = '';
        state.selected = action.payload;
      });
  },
});

export const { resetZoneTypeSelected } = zoneType.actions;
export default zoneType.reducer;
